function isTrueString(str = '') {
  return str.toString().replace(/["']/g, '').toLowerCase() === 'true'
}

export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development'
}

export const isProduction = () => {
  return process.env.NODE_ENV === 'production'
}

export const isApplePayEnabled = () => {
  return isTrueString(process.env.VUE_APP_SHOW_APPLE_PAY)
}
